// 引入axios

import axios from 'axios'
// import { getToken, setToken, fromApp } from '@/utils/auth'
import {
  timeOut } from './config'
axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: timeOut // request timeout requestConfig.timeOut
})
// 请求拦截器
axios.interceptors.request.use(config => {
  // 下载导出文件添加responseType属性
  if (config.url.indexOf('downdmark') != -1) {
    config.responseType = 'blob'
  }
  // config.headers['fromApp'] = fromApp();
  // config.headers['AccessToken'] = getToken();
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
  const refreshToken = response.headers.refresh_token;
  if (refreshToken) {
    // setToken(refreshToken);
  }
  return response
}, err => {
  return Promise.reject(err)
})

export default axios

